import { AppManifestV0, parse as parseV0Manifest } from './app-manifest-v0';
import { AppManifestV1, parse as parseV1Manifest } from './app-manifest-v1';
import { AppManifestV2, parse as parseV2Manifest } from './app-manifest-v2';
import detectManifestVersion, { SomeVersion } from './detect-manifest-version';

type ManifestVersion =
  | {
      version: 'V0';
      data: AppManifestV0;
    }
  | {
      version: 'V1';
      data: AppManifestV1;
    }
  | {
      version: 'V2';
      data: AppManifestV2;
    };

const v0ToV1 = (v0Manifest: AppManifestV0): AppManifestV1 => {
  const {
    assets,
    entrypoint,
    viewEngine,
    environmentProps,
    name,
    path,
    rootnode,
    ...restManifest
  } = v0Manifest;
  const {
    enableSentry,
    release,
    sentryDSN,
    sentryEnvironment,
    environmentLabel,
    ...restEnvironmentProps
  } = environmentProps;
  return {
    assets,
    entrypoint,
    viewEngine,
    ...restManifest, // To keep back compatibility
    config: {
      ...restManifest,
      name,
      path,
      rootnode,
      enableSentry,
      release,
      sentryDsn: sentryDSN,
      sentryEnvironment,
      stageLabel: environmentLabel,
      ...restEnvironmentProps,
    },
  };
};

const parse = (json: SomeVersion): ManifestVersion | null => {
  if (detectManifestVersion(json) === 'V0') {
    return {
      version: 'V0',
      data: parseV0Manifest(json as AppManifestV0),
    };
  }
  if (detectManifestVersion(json) === 'V1') {
    return {
      version: 'V1',
      data: parseV1Manifest(json as AppManifestV1),
    };
  }
  if (detectManifestVersion(json) === 'V2') {
    return {
      version: 'V2',
      data: parseV2Manifest(json as AppManifestV2),
    };
  }

  return null;
};

const tryParse = (json: SomeVersion): ManifestVersion | { version: null; data: {} } => {
  const parsed = parse(json);
  if (parsed == null) {
    return {
      version: null,
      data: json,
    };
  }

  return parsed;
};

const getConfig = (manifest: ManifestVersion) => {
  if (manifest.version === 'V0') {
    return manifest.data;
  }

  return manifest.data.config;
};

export { parse, tryParse, v0ToV1, getConfig, ManifestVersion };
